import type { ReactNode } from "react";

export function IncomeStatCard({ id, title, value, children, action, linkLabel = action, open, onToggle, className = "" }: {
  id: string;
  title: string;
  value: ReactNode;
  children?: ReactNode;
  action: string;
  linkLabel?: string;
  open: boolean;
  onToggle: () => void;
  className?: string;
}) {
  return (
    <button
      id={`${id}-toggle`}
      type="button"
      className={`panel income-stat-card ${className}`}
      aria-label={action}
      aria-describedby={`${id}-value ${id}-meta`}
      aria-expanded={open}
      aria-controls={id}
      onClick={onToggle}
    >
      <span className="income-stat-title">{title}</span>
      <strong id={`${id}-value`}>{value}</strong>
      <span id={`${id}-meta`} className="income-stat-meta">{children}</span>
      <span className="income-stat-action">{open ? "Hide details" : linkLabel}<span aria-hidden="true">{open ? "−" : "+"}</span></span>
    </button>
  );
}

export function IncomeDetailPanel({ id, headingId = `${id}-heading`, title, open, onClose, children }: {
  id: string;
  headingId?: string;
  title: string;
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}) {
  function close() {
    onClose();
    document.getElementById(`${id}-toggle`)?.focus();
  }
  return (
    <section
      id={id}
      className="panel income-detail-panel"
      aria-labelledby={headingId}
      hidden={!open}
      onKeyDown={(event) => {
        if (event.key === "Escape") {
          event.stopPropagation();
          close();
        }
      }}
    >
      <header className="income-detail-heading">
        <h2 id={headingId}>{title}</h2>
        <button type="button" className="quiet small income-detail-close" onClick={close} aria-label={`Close ${title}`}>Close <span aria-hidden="true">×</span></button>
      </header>
      {children}
    </section>
  );
}
